import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import CustomPasswordField from "../inputs/CustomPasswordField";
import { admin_change_password } from "../../../DAL/adminAuth/auth";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: { xs: 360, sm: 595 },
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: 1,
};

export default function ChangePassword({
  openPasswordModal,
  setopenPasswordModal,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    password: "",
    repeatPassword: "",
    oldPassword: "",
  });

  const handleClose = () => {
    setopenPasswordModal(false);
    setInputs({
      password: "",
      repeatPassword: "",
      oldPassword: "",
    });
  };

  const handleChange = (event) => {
    let { name, value } = event.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (inputs.password !== inputs.repeatPassword) {
      enqueueSnackbar("Password and Confirm Password do not match.", {
        variant: "error",
      });
      setIsLoading(false);
    } else {
      let postData = {
        old_password: inputs.oldPassword,
        new_password: inputs.password,
        confirm_password: inputs.repeatPassword,
      };
      const result = await admin_change_password(postData);
      if (result.code === 200) {
        setInputs({});
        setIsLoading(false);
        handleClose();
        localStorage.clear();
        navigate("/login");
        enqueueSnackbar("Password Changed Successfully", {
          variant: "success",
        });
      } else {
        setIsLoading(false);
        enqueueSnackbar(result.message, { variant: "error" });
      }
    }
  };

  return (
    <div>
      <Modal
        disableTypography="true"
        open={openPasswordModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handlePasswordSubmit}>
          <Box sx={style} className="modal-theme">
            <div
              className="text-end modalIcon pointer"
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </div>
            <h3 className="text-center mb-4">Change Password</h3>

            <div className="col-12 mt-3">
              <CustomPasswordField
                id="outlined-basic"
                label="Old Password"
                name="oldPassword"
                Required={true}
                onChange={handleChange}
                value={inputs.oldPassword}
              />
            </div>
            <div className="col-12 mt-3">
              <CustomPasswordField
                id="outlined-basic"
                label="New Password"
                name="password"
                Required={true}
                onChange={handleChange}
                value={inputs.password}
              />
            </div>
            <div className="col-12 mt-3">
              <CustomPasswordField
                id="outlined-basic"
                label="Confirm Password"
                name="repeatPassword"
                Required={true}
                onChange={handleChange}
                value={inputs.repeatPassword}
              />
            </div>

            <div className="col-12 mt-3">
              <Button type="submit" variant="contained" className="w-100">
                {isLoading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Box>
        </form>
      </Modal>
    </div>
  );
}
